// @flow

import React from 'react';
import styled from 'styled-components';

const StyledModalContent = styled.div`
  padding-top: .25em;
`;

const ModalContent = ({ children }: {children: React.Node}) => (
    <StyledModalContent>
        { children }
    </StyledModalContent>
);

export default ModalContent;
